import { render, staticRenderFns } from "./EstablishmentDetails.vue?vue&type=template&id=5232aa78&"
import script from "./EstablishmentDetails.vue?vue&type=script&lang=js&"
export * from "./EstablishmentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports